let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("4RcLg"), load("15VrD"), load("48JGY"), load("63MsJ"), load("6aruy")]).then(() => parcelRequire('9VKkC'));